import React from "react";

import {
  PrimaryBlockType,
  primaryBlock,
  PrimaryBlockConfig,
  SecondaryBlockSize,
  TertiaryBlockSize,
  BlockTheme,
  renderSecondaryBlock,
  renderTertiaryBlock,
  getDefaultProps,
  MediaProp,
} from "@kameleon-core/lib";
import { Variants } from "@kameleon-util/global-theme";
import { Box } from "theme-ui";
import defaults from "../defaults.json";
import { LayoutProps } from "../types/prop-types";

export type ItemType = {
  image: MediaProp;
  name: string;
  description: string;
  title: string;
} & PrimaryBlockType<LayoutProps>;

/** ServicesItem PrimaryCollection */
export const blockConfig: PrimaryBlockConfig = {
  secondaryBlockSize: SecondaryBlockSize.Medium,
  tertiaryBlockSize: TertiaryBlockSize.Default,
  blockTheme: BlockTheme.dark,
};

export const ContentCollectionItem = primaryBlock<ItemType>(
  { isInnerBlock: true, ...blockConfig },
  ({
    image,
    name,
    description,
    title,
    SecondaryBlock,
    TertiaryBlock,
  }: ItemType) => (
    <Box
      className="header88_card"
      sx={{ backgroundImage: `url(${image.url})` }}
    >
      <Box className="max-width-medium">
        <Box className="margin-bottom margin-xsmall">
          <Variants.TagLine>{name}</Variants.TagLine>
        </Box>
        <Box className="margin-bottom margin-small">
          <Variants.Heading>{title}</Variants.Heading>
        </Box>
        <Variants.ParagraphMedium>{description}</Variants.ParagraphMedium>
        {renderSecondaryBlock(SecondaryBlock)}
        {renderTertiaryBlock(TertiaryBlock)}
      </Box>
      <Variants.Opacity />
    </Box>
  )
);

ContentCollectionItem.defaultProps = getDefaultProps<ItemType>({
  layoutProps: defaults.layoutProps,
  contentProps: defaults.contentProps.PrimaryBlocks[0],
});
